import request from 'axios';
import wx from 'weixin-js-sdk';

//微信票据
function WeChatVoucher(url, api) {
    return request.post('/api/wechat/js_sdk', {
        api,
        url
    })
}

export function Voucher(url, api) {
    return new Promise((resolve, reject) => {
        WeChatVoucher(url, api).then(voucher => {
            console.log(voucher);
            wx.config(voucher.data.data);
            wx.ready(() => {
                console.log('wx.ready');
                resolve(wx);
            });
            wx.error((res) => {
                console.log('wx err', res);
                reject(res);
            });
        }).catch(() => {
            reject('接口异常');
        });
    });
}

// 分享
export function Share(title, thumbnail, description, url, type = 'link') {
    return new Promise((resolve, reject) => {
        Voucher(url, 'onMenuShareAppMessage,onMenuShareTimeline').then(_wx => {
            _wx.onMenuShareAppMessage({
                title: title, // 分享标题
                desc: description, // 分享描述
                link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: thumbnail, // 分享图标
                type: type, // 分享类型,music、video或link，不填默认为link
                dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                success() {
                    // 用户点击了分享后执行的回调函数
                    resolve();
                }
            });

            _wx.onMenuShareTimeline({
                title: title, // 分享标题
                // desc: description, // 分享描述
                link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: thumbnail, // 分享图标
                // type: type, // 分享类型,music、video或link，不填默认为link
                // dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                success() {
                    // 用户点击了分享后执行的回调函数
                    resolve();
                }
            });
        }).catch(err => {
            reject(err)
        });
    });
}
